export default __webpack_public_path__ + "static/media/bg.e781347d.png";